import React from "react";
import CourseItem from "./courseItem/courseItem";
import classes from "./scheduledCourses.module.css";
import Title from "../../containers/title/title";
import TrainingSubscriptions from "./trainingSubscriptions/trainingSubscriptions";
import FreeTrialForm from "./freeTrialForm/freeTrialForm";

function ScheduledCourses(props) {
  const formatScheduleText = (description) => {
    if (!description) return '';
    
    const parts = description.split('OR').map(part => part.trim());
    if (parts.length === 2) {
      return [
        parts[0].replace('FRI', ''),  // Remove FRI from first part
        'FRI ' + parts[1]  // Add FRI to second part
      ].filter(Boolean).join('\n');
    }
    return description;
  };

  const renderMobileView = () => {
    const courses = props.academy?.courses?.scheduled || [];
    return (
      <div className={classes.mobileGroup}>
        {courses.map((activity, index) => (
          <CourseItem 
            key={activity.id} 
            {...activity} 
            description={formatScheduleText(activity.description)}
            index={index} 
          />
        ))}
      </div>
    );
  };

  return (
    <section className={classes.scheduledCourses}>
      <Title title={parseInt(localStorage.getItem('language')) === 1 
        ? "COURSE DETAILS" 
        : "تفاصيل الدورة"} 
      />
      <div className={classes.Container}>
        <div className={classes.DarkEffect}>
          <p className={classes.description}>
            {parseInt(localStorage.getItem('language')) === 1 
              ? "Become the next football star, join our Academy, and train with the best coaches!"
              : "كن نجم كرة القدم القادم، انضم إلى أكاديميتنا وتدرب مع أفضل المدربين!"}
          </p>
          <div className={classes.courseGrid}>
            <div className={classes.desktopView}>
              {props.academy?.courses?.scheduled?.map((activity, index) => (
                <CourseItem key={activity.id} {...activity} index={index} />
              ))}
            </div>
            <div className={classes.mobileView}>
              {renderMobileView()}
            </div>
          </div>
          <TrainingSubscriptions academy={props.academy} setSelectedPlan={props.setSelectedPlan}
            setShowAcademyRegistrationForm={props.setShowAcademyRegistrationForm} setSelectedLocation={props.setSelectedLocation}
            isAuthenticated={props.isAuthenticated} setShowLoginForm={props.setShowLoginForm}/>
          <FreeTrialForm academy={props.academy} />
        </div>
      </div>
    </section>
  );
}

export default ScheduledCourses;
